<template lang="pug">
div
  template(v-for="(n, index) in 1")
    .body-row
      .cell(
        v-for="placeholder in columns",
        :class="[placeholder.cellWidth, placeholder.textAlign]"
      )
        <cell-content v-show="placeholder.show" :data="placeholder.key" class="glow-text"/>
</template>

<script>
import CellContent from './Cell-Content'

export default {
    props: {
        columns: {
            type: Array,
            default: () => []
        }
    },
    components: {
        CellContent
    }
}
</script>
